import store from '@/store'
export default [
  {
    path: '/news',
    name: 'news',
    meta: { requiresAuth: true },
    component: () => import('@/pages/news/index.vue')
  },
  {
    path: '/news/create',
    name: 'news-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/news/create.vue')
    // beforeEnter: async (to, from, next) => {
    //   await store.dispatch('news/dataBeforeCreate')
    //   next()
    // }
  },
  {
    path: '/news/:id',
    name: 'news-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/news/edit.vue'),
    beforeEnter: async (to, from, next) => {
      await store.dispatch('news/find', to.params.id)
      next()
    }
  }
]
